import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-plataforma-badge',
    templateUrl: './plataforma-badge.component.html',
    styleUrls: ['./plataforma-badge.component.less']
})
export class PlataformaBadgeComponent {
    @Input() logoURL: string;
    @Input() logoURLWidth = '30px';
    @Input() isShowNome = true;
    @Input() nome: string;
}
